module.exports = __webpack_public_path__ + "static/img/c6.e64f6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c6.png
// module id = HAwK
// module chunks = 0